import { Chip, Container, Grid, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { getTransactions } from '../../api';
import './styles.css'
import Cookies from 'universal-cookie'
// import { BsArrowRight } from 'react-icons/bs'
import moment from 'moment/moment';

function Transactions() {
    const cookie = new Cookies()
    const id = cookie.get('id');
    const [transactions, setTransactions] = useState([]);

    useEffect(
        () => {
            getTransactions(id).then(async res => {
                // const transactionResult = [];
                // res.data.forEach(element => {
                //     if (element.status === 0) {
                //         transactionResult.push(element)
                //     }
                // });

                setTransactions(res.data.reverse())
            }).catch(error => console.log(error));
        },
        [])



    return (
        <Container>
            <Grid container fluid >
                <Grid lg={12} md={12} sm={12} xs={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' , height:"calc(100vh - 69px)"}} >
                    <div className='transactionsWrapper'>
                        <div className='transactionstTitleContainer'>
                            <p className='transactionsTitle'>Transactions</p>
                        </div>
                        <div className='transactionsContainer'>
                            <Table responsive="sm">
                                <TableHead>
                                    <TableRow style={{ textAlign: 'left' }}>
                                        <TableCell align='center' style={{color:"var(--white)"}}><b>From</b></TableCell>
                                        <TableCell align='center' style={{color:"var(--white)"}}><b>To</b></TableCell>
                                        <TableCell align='center' style={{color:"var(--white)"}}><b>Amount</b></TableCell>
                                        <TableCell align='center' style={{color:"var(--white)"}}><b>Currency</b></TableCell>
                                        <TableCell align='center' style={{color:"var(--white)"}}><b>Date</b></TableCell>
                                        <TableCell align='center' style={{color:"var(--white)"}}><b>Status</b></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        transactions?.map(item => (
                                            <>
                                                <TableRow key={item._id}>
                                                    <TableCell align='center' style={{color:"var(--white)"}}><p>{cookie.get('username')}</p></TableCell>

                                                    <TableCell align='center' style={{color:"var(--white)"}}><p>{item.receiver}</p></TableCell>

                                                    <TableCell align='center' style={{color:"var(--white)"}}><p>{item.amount}</p></TableCell>
                                                    <TableCell align='center' style={{color:"var(--white)"}}><p>{item.sender.currency}</p></TableCell>
                                                    <TableCell align='center' style={{color:"var(--white)"}}><p>{moment(item.createAt).format('L')}</p></TableCell>

                                                    <TableCell align='center'>
                                                        {
                                                            item.status === 0 ?
                                                                <>
                                                                    <Chip label="Pending" color="warning" />
                                                                </>
                                                                :
                                                                <>
                                                                    <Chip label="Confirmed" color="success" />
                                                                </>
                                                        }
                                                    </TableCell>
                                                </TableRow>

                                            </>

                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </div>
                    </div>
                </Grid>
            </Grid>
        </Container>
    )
}

export default Transactions